









































































import { Component, Vue, Watch } from "vue-property-decorator";
import { namespace } from "vuex-class";
import { Checkbox, CheckboxGroup, Button, Field, Popup } from "vant";
import CustomUploader from "@/components/CustomUploader.vue";

const createAccountModule = namespace("createAccount");
const failReasonModule = namespace("failReason");

@Component({
  name: 'TaxResidentInfoPageTwo',
  components: {
    [Checkbox.name]: Checkbox,
    [CheckboxGroup.name]: CheckboxGroup,
    [Button.name]: Button,
    [Field.name]: Field,
    [Popup.name]: Popup,
    customUploader: CustomUploader
  }
})
export default class TaxResidentInfoPageTwo extends Vue {
  @createAccountModule.Getter("tax_place") tax_place: any;
  @createAccountModule.Getter("country_list") country_list: any;
  @createAccountModule.Getter("id_card_ocr_info") id_card_ocr_info: any;
  @createAccountModule.Getter("open_mode_info") open_mode_info: any;
  @failReasonModule.Mutation("SAVE_MODIFIED_FAIL_REASON")
  saveModifiedFailReason: any;

  list: any = [];

  @Watch("tax_place", { deep: true, immediate: true })
  watchTaxPlace(val) {
    
    const { choice, extra } = val;
    const { hot, normal } = this.country_list;

    const chioce_temp = choice.map(item => {
      return hot.find(country => {
        return item == country.id;
      });
    });
    const extra_temp = extra.map(item => {
      return normal.find(country => {
        return item == country.id;
      });
    });

    const arr = [...chioce_temp, ...extra_temp];

    this.list = arr.map(item => {
      if (item.id == 2) {
        return {
          tax_area_id: item.id,
          tax_area: item.name,
          // belong_area: "",
          tax_no:
            this.open_mode_info.open_status == 2
              ? this.id_card_ocr_info.id_card
              : ""
        };
      } else if (item.id == 1) {
        return {
          tax_area_id: item.id,
          tax_area: item.name,
          tax_no:
            this.open_mode_info.open_status == 1
              ? this.id_card_ocr_info.id_card
              : ""
        };
      } else {
        return {
          tax_area_id: item.id,
          tax_area: item.name,
          tax_no: ""
        };
      }
    });
  }
  get bgColor() {
    return this.$store.getters["common/bgColor"];
  }

  get isModify() {
    return this.$route.query.modify == "1";
  }

  get isSubmitDisable() {
    return this.list.some(item => {
      let flag = false;
      for (const key in item) {
        if (item[key] === "") {
          return (flag = true);
        }
      }
      return flag;
    });
  }

  filterReadOnly(item) {
    if (item.tax_area_id == 2) {
      return !this.isModify && this.open_mode_info.open_status == 2;
    } else if (item.tax_area_id == 1) {
      return !this.isModify && this.open_mode_info.open_status == 1;
    } else {
      return false;
    }
  }

  handleSaveResidentInfo() {
    const params = {
      tax_resident: this.list
    };
    (this as any).$apis
      .saveResidentInfo(params)
      .then(() => {
        if (this.$route.query.modify == "1") {
          this.saveModifiedFailReason(4);
          this.$router.go(-2);
        } else {
          this.$router.push("/w8ben");
        }
      })
      .catch(e => {
        
      });
  }
}
